<template>
    <dv-capsule-chart :config="config" style="width:300px;height:200px" />
  </template>
  
  <script>
  export default {
    name: "SanRanking",
    data() {
      return {
        config: {},
        //折线数据
  
      }
    },
    methods:{
  
    },
  
    created() {
  
        let data=[];
        data[0]={'name':'消费帮扶','value':'300000'};
        data[1]={'name':'风电光伏帮扶','value':'100000'};
        data[2]={'name':'订单农业帮扶','value':'50000'};
        data[3]={'name':'扶贫大棚','value':'102'};
        data[4]={'name':'扶贫超市','value':'260'};
        // data[5]={'name':'技术培训帮扶','value':'36'};
        // data[6]={'name':'扶贫车间','value':'10'};



        this.config = {
          data: data,
          colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
          unit: '元',
          showValue: true
        }
    },
    watch: {
  
    }
  }
  </script>
  
  <style scoped>
  
  </style>